import React from "react";
import styled from "styled-components";
import { color, font } from "../templates/ui";
import IconChevronRight from "./icons/IconChevronRight";

const StyledMenuLink = styled.a`
  display: flex;
  align-items: center;
  padding: ${props => {
    if (props.isOffCanvasMenu) {
      return "10px";
    }

    if (props.isFooterLink) {
      return "6px";
    }

    if (props.isChild) {
      return "18px";
    }

    return "0 14px";
  }};
  color: ${color.body.base};
  font-size: ${props => {
    if (props.isFooterLink) {
      return "14px";
    }

    if (props.isOffCanvasMenu) {
      return "18px";
    }

    return "16px";
  }};
  font-weight: 700;
  text-decoration: none;
  transition: height 0.3s ease-out 0s, line-height 0.3s ease-out 0s;
  border-radius: ${props => (props.isFooterLink ? "3px" : "0")};
  font-family: ${font.family.head};

  @media only screen and (min-width: 992px) {
    &:before {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      display: block;
      content: ${props => {
        if (props.isMainMenuLink) {
          return "''";
        }

        if (props.isOffCanvasMenu) {
          return "none";
        }

        return "none";
      }};
      background-color: ${color.primary.base};
      height: 3px;
      transition: ${props =>
        props.isOffCanvasMenu
          ? "transition: background-color .3s ease-out 0s,height .3s ease-out 0s,line-height .3s ease-out 0s"
          : "transform 0.24s ease-in-out 0ms"};
      transform: translateX(-120%);
    }
  }
`;

const StyledChevronRight = styled(IconChevronRight)`
  width: 12px;
  height: 11px;
  fill: ${color.body.base};
  opacity: 0.7;
  margin-right: 4px;
`;

const MenuLink = ({ href, title, children, className, isFooterLink, isMainMenuLink, isOffCanvasMenu, isChild }) => (
  <StyledMenuLink
    href={href}
    title={title}
    className={className}
    isFooterLink={isFooterLink}
    isMainMenuLink={isMainMenuLink}
    isOffCanvasMenu={isOffCanvasMenu}
    isChild={isChild}
  >
    {isFooterLink && <StyledChevronRight />}
    {children}
  </StyledMenuLink>
);

export default MenuLink;
